// security/AzureAuthService.ts
import msalInstance from "./msalInstance";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";
import { getConfiguredMsalAuthority } from "./msalInstance";

let interactionInFlight = false;

export const isMsalInteractionInProgress = (): boolean => {
  if (interactionInFlight) return true;

  const href = window.location.href || "";
  if (href.includes("code=") || href.includes("error=")) {
    return true;
  }

  try {
    const clientId = (msalInstance as any)?.config?.auth?.clientId;
    if (clientId) {
      const key = `msal.${clientId}.interaction.status`;
      if (sessionStorage.getItem(key)) {
        return true;
      }
    }
  } catch {}

  return false;
};

export async function handleAzure401(scopes = loginRequest.scopes) {
  if (isMsalInteractionInProgress()) {
    return null;
  }

  const authority = getConfiguredMsalAuthority();
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

  if (!account) {
    interactionInFlight = true;
    try {
      await msalInstance.loginRedirect({ scopes, ...(authority ? { authority } : {}) });
      return null;
    } catch (error: any) {
      interactionInFlight = false;
      if (error?.errorCode === "interaction_in_progress") {
        return null;
      }
      throw error;
    }
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      account,
      scopes,
      ...(authority ? { authority } : {}),
    });
    return response.accessToken;
  } catch (error) {
    if ((error as any)?.errorCode === "interaction_in_progress") {
      return null;
    }

    if (
      error instanceof InteractionRequiredAuthError ||
      (error as any)?.errorCode === "interaction_required"
    ) {
      interactionInFlight = true;
      try {
        await msalInstance.loginRedirect({ scopes, ...(authority ? { authority } : {}) });
        return null;
      } catch (redirectError: any) {
        interactionInFlight = false;
        if (redirectError?.errorCode === "interaction_in_progress") {
          return null;
        }
        throw redirectError;
      }
    }
    throw error;
  }
}
